const OnboardingSummary = () => import('@/views/Summary/OnboardingSummary.vue')

export default [
  {
    path: '/onboarding/:merchantID/summary',
    component: OnboardingSummary,
    name: 'OnboardingSummary'
  }
]
